import React, { useEffect, useState } from 'react';

import Grid from "@mui/material/Grid2";

import { MindsetInsightCard } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { MindsetResult } from "@/types";
import { filterItems } from "@/utils";


interface MindsetsViewProps {
  data: MindsetResult[];
}

const MindsetsView: React.FC<MindsetsViewProps> = ({ data }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [scores, setScores] = useState<MindsetResult[]>([]);

  useEffect(() => {
    setScores(filterItems(data, scoreType.value));
  }, [data, scoreType]);

  const maxScore =
    scoreType.value === "rate"
      ? 1
      : Math.min(
        Math.max.apply(
          Math,
          scores.map((x) =>
            Number(x[scoreType.value as keyof MindsetResult]),
          ),
        ),
        1.5,
      );
  const minScore =
    scoreType.value === "rate"
      ? Math.min.apply(
        Math,
        scores.map((x) => Number(x[scoreType.value as keyof MindsetResult])),
      )
      : Math.max(1 - (maxScore - 1), 0);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Grid container spacing={2}>
          {scores.map((mindset, index) => (
            <Grid key={mindset.tag_name || index}>
              <MindsetInsightCard
                mindset={mindset}
                score={scoreType.value}
                minValue={minScore}
                maxValue={maxScore}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MindsetsView;
